import axios from '@/api/axiosConfig'
import { ApiRoutes } from '../ApiRoutes'
import type { AxiosResponse } from 'axios'

export type ZBEdgeUserSortBy = 'LastSentDate' | 'FirstName' | 'LastName' | 'Email' | 'CreatedDate'
export type ZBEdgeUserSortOrder = 'Asc' | 'Desc'

export interface ZBEdgeUser {
  userId: string
  firstName: string | null
  lastName: string | null
  email: string | null
  phoneNumber: string | null
  phoneCountryCode: string | null
  createdDate: string | null
  lastSentDate: string | null
}

export interface GetZBEdgeUsersRequest {
  pageNumber: number
  pageSize: number
  sortBy: ZBEdgeUserSortBy
  sortOrder: ZBEdgeUserSortOrder
  phoneNumber?: string | null
  phoneCountryCode?: string | null
  email?: string | null
  firstName?: string | null
  lastName?: string | null
}

export interface GetZBEdgeUsersResponse {
  users: ZBEdgeUser[]
  totalCount: number
  pageNumber: number
  pageSize: number
}

export interface ZBEdgeUserApplication {
  appId: number
  appKey: string | null
  appName: string | null
}

export interface GetZBEdgeUserDetailResponse {
  userId: string
  email: string | null
  firstName: string | null
  lastName: string | null
  prefix: string | null
  suffix: string | null
  npi: string | null
  phone: string | null
  phoneCountryCode: string | null
  lastLoginTime: string | null
  isFederated: boolean
  isDeactivated: boolean
  applications: ZBEdgeUserApplication[]
}

export interface UpdateZBEdgeUserDetailRequest {
  userId: string
  firstName: string
  lastName: string
  prefix: string | null
  suffix: string | null
  npi: string | null
  phone: string
  phoneCountryCode: string
  email: string
}

export async function getZBEdgeUserDetail(userId: string): Promise<AxiosResponse<GetZBEdgeUserDetailResponse>> {
  return await axios.get(ApiRoutes.ZBEdgeUser.GetUser, {
    params: { UserId: userId }
  })
}

export async function updateZBEdgeUserDetail(request: UpdateZBEdgeUserDetailRequest): Promise<AxiosResponse> {
  return await axios.put(ApiRoutes.ZBEdgeUser.UpdateUser, request)
}

export async function getZBEdgeUsersWithFilter(request: GetZBEdgeUsersRequest): Promise<AxiosResponse<GetZBEdgeUsersResponse>> {
  return await axios.get(ApiRoutes.ZBEdgeUser.GetUsersList, {
    params: {
      PageNumber: request.pageNumber,
      PageSize: request.pageSize,
      SortBy: request.sortBy,
      SortOrder: request.sortOrder,
      PhoneNumber: request.phoneNumber,
      PhoneCountryCode: request.phoneCountryCode,
      Email: request.email,
      FirstName: request.firstName,
      LastName: request.lastName
    }
  })
}
